import React from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'

class ConfirmButton extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      modal: false
    }
  }

  toggle = () => {
    this.setState({ modal: !this.state.modal })
  }

  onConfirm = () => {
    this.setState({ modal: false })
    this.props.onConfirm()
  }

  render () {
    return (
      <span>
        <Button className={this.props.className} disabled={this.props.disabled} color={this.props.color} onClick={this.toggle}>{this.props.children}</Button>
        <Modal isOpen={this.state.modal} toggle={this.toggle} zIndex={2000}>
          <ModalHeader toggle={this.toggle}>{ this.props.title }</ModalHeader>
          <ModalBody>
            { this.props.message }
          </ModalBody>
          <ModalFooter>
            <Button color={this.props.color} onClick={this.onConfirm}>OK</Button>
            &nbsp;
            <Button color='secondary' onClick={this.toggle}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </span>
    )
  }
}
ConfirmButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]).isRequired,
  color: PropTypes.string,
  disabled: PropTypes.bool
}
ConfirmButton.defaultProps = {
  color: 'primary',
  disabled: false
}

export default ConfirmButton



// WEBPACK FOOTER //
// ./src/components/ConfirmButton/ConfirmButton.js